import React, { FC } from 'react';
import getConfig from 'next/config';
import { withOptimizely, WithOptimizelyProps } from 'shared/optimizely';
import useLiveRamp from 'shared/hooks/optimizely/useLiveRamp';

const { publicRuntimeConfig } = getConfig();

import htmlRebrand from './assets/rebrand.html.txt';

/**
 * 12-Mar-21: To help diagnose a production issue with nginx SSI we are
 * directly inlining the html and script snippets here
 */
const TemporaryHardCodedInclude: FC<WithOptimizelyProps> = ({ optimizely }) => {
    const _useLiveRamp = useLiveRamp(optimizely);

    if (process.env.NODE_ENV !== 'production') {
        return null;
    }

    return _useLiveRamp ? null : (
        <div
            data-testid="consent-banner"
            dangerouslySetInnerHTML={{
                __html: htmlRebrand.replace(
                    '{{segmentID}}',
                    publicRuntimeConfig.SEGMENT_ID
                )
            }}
        />
    );
};

export default withOptimizely(TemporaryHardCodedInclude);
